/* jshint esversion: 6 */
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

/** Forces child route to remount when path changes (fixes URL updating without UI swap). */
export default function PharmacyLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <Outlet key={location.pathname} />;
}
